const Loader = () => {
  return (
    <div className='spinner justify-content-center'>
      <div className='spinner-border' role='status'>
        <span className='sr-only'>
          Loading...
        </span>
      </div>
    </div>
  )
}

export default Loader
